import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'builtByLabel',
})
export class BuiltByLabelPipe implements PipeTransform {
  FRIENDLY_STATUSES = {
    hospitable: 'Hospitable',
    partner: 'Hospitable partners',
  };

  transform(builtBy: string): string {
    if (!builtBy) {
      return 'All';
    }

    return this.FRIENDLY_STATUSES[builtBy];
  }
}
